export default __webpack_public_path__ + "assets/header.eb1163c526fa9641c3b7bc7c4d2e7a71.jpg";